import { useProjects } from "@/hooks/useProjects"
import { ApiRequestError } from "@/lib/api/projects"
import { Link, useParams } from "wouter"

export function ProjectsPage() {
  const { setSlug } = useParams<{ setSlug?: string }>()
  const activeSetSlug = setSlug ?? "default"
  const { isError, error } = useProjects(activeSetSlug)

  const tokenInUrl = new URLSearchParams(window.location.search).has("token")
  const hadToken = (error instanceof ApiRequestError && error.hadToken) || tokenInUrl
  const status = error instanceof ApiRequestError ? error.status : null
  const isUnauthorized = status === 401
  const isNotFound = status === 404
  const isProtectedSet = activeSetSlug !== "default"

  if (!isError) {
    return <div className="pointer-events-none h-full w-full" />
  }

  if (isUnauthorized && isProtectedSet) {
    return (
      <div className="pointer-events-none flex h-full w-full items-center justify-center p-6">
        <div className="pointer-events-auto max-w-md rounded-xl border border-white/20 bg-black/60 p-5 text-foreground backdrop-blur-sm">
          <h2 className="text-lg font-semibold">This gallery is protected.</h2>
          <p className="mt-2 text-sm text-foreground/75">
            {hadToken
              ? "The token in this link is invalid or expired. Ask for a new access link."
              : "You need an access link with a valid token to view this gallery."}
          </p>
          <div className="mt-4">
            <Link to="/projects" className="text-sm text-foreground/80 underline-offset-4 hover:text-foreground hover:underline">
              Go to public gallery
            </Link>
          </div>
        </div>
      </div>
    )
  }

  if (isNotFound) {
    return (
      <div className="pointer-events-none flex h-full w-full items-center justify-center p-6">
        <div className="pointer-events-auto max-w-md rounded-xl border border-white/20 bg-black/60 p-5 text-foreground backdrop-blur-sm">
          <h2 className="text-lg font-semibold">Gallery not found.</h2>
          <p className="mt-2 text-sm text-foreground/75">The requested gallery set does not exist.</p>
          <div className="mt-4">
            <Link to="/projects" className="text-sm text-foreground/80 underline-offset-4 hover:text-foreground hover:underline">
              Go to public gallery
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="pointer-events-none flex h-full w-full items-center justify-center p-6">
      <div className="pointer-events-auto max-w-md rounded-xl border border-white/20 bg-black/60 p-5 text-foreground backdrop-blur-sm">
        <h2 className="text-lg font-semibold">Could not load this gallery.</h2>
        <p className="mt-2 text-sm text-foreground/75">Try reloading or using a different gallery link.</p>
      </div>
    </div>
  )
}
